import qs from 'qs';
import routes from './constants';
import instance from './instance';

export const fetchPost = async (data: { timelineid: string }) => {
  const response = await instance.post(routes.API_POST,
    qs.stringify(data)
  );
  return response.data;
};